import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css"; // CSS file for styling
import logo from "../components/asstes/Logo__1___1_.png"; // Ensure the correct path
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false); // State to toggle mobile menu

  // Toggle mobile menu on button click
  const toggleMenu = () => {
    setIsMobile(!isMobile);
  };

  // Close menu when a link is clicked
  const closeMenu = () => {
    setIsMobile(false);
  };
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/");
  };
  return (
    <nav className="navbar">
      <div className="logo">

        

  <img src={logo} alt="Logo" className="logo" style={{ width: "60px", height: "60px", cursor: "pointer" }}       onClick={handleClick}
/>



      </div>

      {/* Toggle button for mobile */}
      <div className="toggle-btn" onClick={toggleMenu}>
        <div></div>
        <div></div>
        <div></div>
      </div>

      <ul className={`nav-links ${isMobile ? "active" : ""}`}>
        <li><Link to="/" onClick={closeMenu}>Home</Link></li>
        <li><Link to="/about" onClick={closeMenu}>Who We Are</Link></li>
        <li><Link to="/services" onClick={closeMenu}>Properties</Link></li>
        <li><Link to="/contact" onClick={closeMenu}>Contact</Link></li>
        <li><Link to="/admin/contacts" onClick={closeMenu}></Link></li> {/* Fixed the Admin link */}
      </ul>
    </nav>
  );
};

export default Navbar;
